import React, {useEffect, useState} from 'react'
import {updateResource} from "../../service/http-service";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'
import {DatePickerComponent} from "../../ui/DatePickerComponent";

export const ProfileScientificPaperForm = ({entityTemp, setEntityTemp, title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()

    const [showNameError, setShowNameError] = useState(false)

    useEffect (() => {
        setEntity(entityTemp)
    }, []);

    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <div className="col-lg-10 offset-lg-1">
                            <input className="w-100"
                                   type="text" required={true} placeholder="Назив на научниот труд"
                                   value={entity.name}
                                   onChange={(e) => {
                                       setEntity({...entity, name: e.target.value})
                                       setShowNameError(false)
                                   }}
                            />
                            {showNameError && <b>Ве молиме внесете назив на научниот труд</b>}
                            <input className="w-100 my-3"
                                   type="text" required={true} placeholder="Место на објавување"
                                   value={entity.publishedIn}
                                   onChange={(e) => setEntity({...entity, publishedIn: e.target.value})}
                            />
                            <div className="w-100">
                                <label className="w-100 lightBlue">Датум на објава</label>
                                <DatePickerComponent
                                    maxDate={new Date()}
                                    selectedDate={entity.publishDate}
                                    onChange={(e)=> setEntity({...entity, publishDate:e})}
                                    placeholder="dd.mm.yyyy"/>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between">
                            <div
                                className="btn-form"
                                onClick={()=>
                                {setAddEntity(false)
                                    setEntityTemp({candidate: entity.candidate})
                                }}
                            >Затвори</div>
                            <div
                                className="btn-form"
                                onClick={(e) => {
                                    if(entity.name && entity.name.length > 0) {
                                        updateResource('candidate_scientific_papers', entity)
                                            .then((data) => {
                                                console.log(data.data)
                                                setAddEntity(false)
                                                setEntityTemp({candidate: entity.candidate})
                                                setUpdateEntity(!updateEntity)
                                                setShowNameError(false)
                                            })
                                    } else {
                                        setShowNameError(true)
                                    }
                                }}
                            >Зачувај</div>
                        </div>
            </>
            )
                }
        </div>
    )
}